
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TextField extends Vue {
	@Prop({ type: String, default: '' }) private appendIcon!: string;
	@Prop({ type: String, default: '' }) private id!: string;
	@Prop({ type: String, default: '' }) private label!: string;
	@Prop({ type: String, default: '' }) private name!: string;
	@Prop({ type: String, default: '' }) private placeholder!: string;
	@Prop({ type: String, default: '' }) private prefix!: string;
	@Prop({ type: String, default: '' }) private suffix!: string;
	@Prop({ type: String, default: '' }) private prependInnerIcon!: string;
	@Prop({ type: String, default: '' }) private hint!: string;
	@Prop({ type: String, default: 'text' }) private type!: string;
	@Prop({ type: String, default: undefined }) private autocomplete!: string | undefined;
	@Prop({ type: [String, Array, Object], default: '' }) private customClass!: string | string[] | object;
	@Prop({ type: [String, Array], default: () => [] }) private errorMessages!: string | string[];
	@Prop({ type: [String, Array], default: () => [] }) private messages!: string | string[];
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, default: false }) private outlined!: boolean;
	@Prop({ type: Boolean, default: false }) private readonly!: boolean;
	@Prop({ type: [Boolean, Number, String], default: undefined }) private counter!: boolean | number | string | undefined;
	@Prop({ type: [Boolean, String], default: false }) private hideDetails!: boolean | string | undefined;
	@Prop({ type: [Boolean, String], default: false }) private loading!: boolean | string;
	@Prop({ type: [Number, String], default: undefined }) private maxlength!: number | string | undefined;
	@Prop({ default: '' }) private value!: any;

	private onKeydown(event: KeyboardEvent): void {
		this.$emit('keydown', event);
		if (event.key === 'Enter') {
			(event.target as HTMLInputElement).blur();
		}
	}
}
